export const datePickerFormat = "DD/MM/YYYY";
export const dateFormatForDisplay = "dd/MM/yyyy"
export const datePickerPlaceholder = "dd/mm/yyyy"
export const dateToSaveFormat = "yyyy-MM-dd'T00:00:00'"
export const dateFormatForOverview = "MMMM do yyyy"
export const STATUS_COLOR_MAP = {
    'Light_grey': '#d6d6d6',
    'Dark_grey': '#607d8b',
    'Magenta_Red': '#ffab00',
    'Amber_Yellow': '#19c142',
    'Green': '#0078dc',
    'Red': '#fc0d1b',
} as const;
export const filterOutFlagsKeys = ["3"];
